var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4197 41.8395C34.9676 41.8395 41.8395 34.9676 41.8395 26.4197C41.8395 17.8718 34.9676 11 26.4197 11C17.8719 11 11 17.8718 11 26.4197C11 34.9676 17.8719 41.8395 26.4197 41.8395Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9394 28.85C30.945 28.85 31.783 28.012 31.783 27.0901C31.783 26.1683 30.945 25.3303 29.9394 25.3303C28.9337 25.3303 28.0957 26.1683 28.0957 27.0901C28.0957 28.012 28.9337 28.85 29.9394 28.85Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4196 41.8395C21.3077 41.8395 17.2013 34.9676 17.2013 26.4197C17.2013 17.8718 21.3077 11 26.4196 11",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.a56eaddbdb0ca752928143b383c94281.svg";
export { ForwardRef as ReactComponent };